
import TableList from "@components/templates/tablelist";
import { HttpGetDynamicErpsku, HttpinActiveErpsku, HttpDeleteErpsku, HttpRecoverErpsku } from "@/service/sfp/sfp";
import compUpdate from './update';
import { mapState,mapGetters } from "vuex";
export default {
    components: {
        compUpdate
    },
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            erpSkusList:[],
        };
    },
    methods: {
        ajaxRequest: HttpGetDynamicErpsku,
        // interceptRequest(params){
        //     params.country = params.search.country
        //     delete params.search.country
        //     // console.log(params)
        //     return params
        // },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(type!='addnewpage'){
                if(batch){
                    params=(params||this.checkedData.join(','))+'';
                    if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
                }
            }
            switch (type) {
                case "addnewpage":
                    this.operate = {
                        id:params,
                        title: '添加',
                        component: 'compUpdate',
                        show: true,
                        width: 720,
                        showFooter: false,
                        type:'add'
                    };
                    break;
                case "edit":
                    this.operate = {
                        id:params,
                        title: '编辑',
                        component: 'compUpdate',
                        show: true,
                        width: 720,
                        showFooter: false,
                        type:'edit'
                    };
                    break;
                case "query":
                    this.operate = {
                        id:params,
                        title: '查看',
                        component: 'compUpdate',
                        show: true,
                        width: 720,
                        showFooter: false,
                        type:'query'
                    };
                    break;
                case "delete":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{ids:params},
                        title: "批量删除操作",
                        desc:"该记录将被删除，请谨慎操作！",
                        ajaxRequest:HttpDeleteErpsku
                    }
                    break;
                case "failure":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{ids:params},
                        title: "批量失效操作",
                        desc:"该数量的Seller SKU和ERP SKU的绑定关系将失效，请谨慎操作！",
                        ajaxRequest:HttpinActiveErpsku
                    }
                    break;
                case "solodelete":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{ids:params},
                        title: "删除操作",
                        desc:"该记录将被删除，请谨慎操作！",
                        ajaxRequest:HttpDeleteErpsku
                    }
                    break;
                case "solofailure":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{ids:params},
                        title: "失效操作",
                        desc:"该数量的Seller SKU和ERP SKU的绑定关系将失效，请谨慎操作！",
                        ajaxRequest:HttpinActiveErpsku
                    }
                    break;
                case "active":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params},
                        title: "恢复操作",
                        ajaxRequest:HttpRecoverErpsku
                    }
                    break;
                case "allactive":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params},
                        title: "批量生效操作",
                        ajaxRequest:HttpRecoverErpsku
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width:460,
                        showFooter: false,
                        data: { contextId: global.SYSID},
                        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/OrgWarehouseCarrierService/batchImport",
                        name: "excelFile",
                        component: "compUpload",
                        download:this.downloadExcel
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/OrgWarehouseCarrierService/export',{ids:params},'download');
                    break;
                
            }
        },
        downloadExcel(){
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/OrgWarehouseCarrierService/orgWarehouseCarrierTemplate", {}, 'download') 
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, matchStatus } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show:true,
                params:id,
                operate:'edit'
            },{
                label:'删除',
                show:true,
                params:id,
                operate:'solodelete'
            },
            {
                label:'失效',
                show:matchStatus==1,
                params:id,
                operate:'solofailure'
            },
            {
                label:'恢复',
                show:matchStatus==0,
                params:id,
                operate:'active'
            }]
        },
        dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
    },
    computed: {
        ...mapState('boss', ['accounts','countries','products','accountTypes']),
        // table中单据状态的按钮展示
        orderStatus(){
            return [
                {
                    value: '0',
                    label: '有效',
                    theme:'info',
                },
                {
                    value: '1',
                    label: '失效',
                    theme:'error',
                }, 
            ];
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: "添加",
                    operate: "addnewpage",
                    theme: "primary",
                    batch:true,
                },
                {
                    name: "批量失效",
                    operate: "failure",
                    more: true,
                    batch:true,
                },
                {
                    name: "批量删除",
                    operate: "delete",
                    more: true,
                    batch:true,
                },
                {
                    name: "批量恢复",
                    operate: "allactive",
                    more: true,
                    batch:true,
                },
                // {
                //     name: "按查询条件导出",
                //     operate: "export",
                //     more: true,
                //     batch:true,
                // }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            const dropStyle="width:auto;min-width:200px;";
            return  [
                {
                    label: "Seller SKU",
                    key: 'EQ_sellerSku',
                    tag: 'vInput',
                    show:true,
                },
                {
                    label: "ERP SKU",
                    key: 'EQ_erpSku',
                    tag: 'vInput',
                    show:true,
                },
                {
                    label: "店铺",
                    tag: 'vSelect',
                    key: 'EQ_channelId',
                    options:this.accounts.map(function(item){
                        return {
                            value: item.id,
                            label: item.title
                        }
                    }),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options:this.products.map(function(item){
						// console.log(item)
                        return {
                            value: item.id,
                            label: item.name
                        }
					}),
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "状态",
                    tag: 'vSelect',
                    key: 'EQ_matchStatus',
                    options: [
                        {
                            value: '1',
                            label: '有效 '
                        },
                        {
                            value: '0',
                            label: '失效'
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: '操作',
                width: 70,
                render:this.getOperateNodes
            }, 
            {
                title: '店铺',
                key: 'channelFlag',
            },
            
            {
                title: '项目',
                // key: 'lineId',
                render:(h,{row})=>{
                    const id = row.lineId;
                    const product = this.products.filter((item) => {
                        return id == item.id
                    })[0] || {};
                    return product.name
                }
            },
            {
                title: 'Seller SKU ✖ 数量',
                // key: 'warehouseCode',
                render:(h,{row})=>{
                    return <div>{row.sellerSku} ✖ <span class="font-weight numberSpan">{row.quantity}</span></div>
                }
            },
            {
                title: 'ERP SKU',
                key:'erpSku',
            },
            {
                title: '状态',
                maxWidth:100,
                render:(h,{row})=>{
                    return <div>{row.matchStatus==1 ? '有效':'无效'}</div>
                }
            },
            {
                title: '创建时间',
                key: 'createdAt',
                sortable: true,
            },
            {
                title: '更新时间',
                key: 'updatedAt',
                sortable: true
            }
        ];
        },
        
    },

};
